import { BaseItem } from './common';

export const ON = 'on' as const;
export const OFF = 'off' as const;

type Option = typeof ON | typeof OFF;

const FlagNames = [
  'watchOrders',
  'performDynamicVolumeNormalizationForDictations',
  'FingerprintPGAutoExportOnCheckIn',
  'enableCarryForwardProblemGroups',
  'enableDocumentTemplatesInFlowStudio',
  'enableNoteCompletedPushNotifications',
  'exportBillingOnCheckedIn',
  'enableAutomatedLabeling',
  'enableAutomatedStructuring',
  'enableAutomatedTranscribing',
  'enableExperimentalOcr',
  'enableRecommendingFixAndLearn',
  'enableRealTimeManualProcessingOption',
  'enableRealTimeMultiModelTranscribing',
  'enableRealTimeMultiModelFastMerging',
  'enableMobileEditSuggestions',
  'enableSelfServeFormMapping',
  'enableWav2letterAsr',
  'exampleFlag',
] as const;

export type FlagName = (typeof FlagNames)[number];

export interface BaseSetting {
  userId: string;
  name: FlagName;
  option: Option;
}

export interface Setting extends BaseItem, BaseSetting {}

export type FlagMap = Record<string, string>;

export interface FlagOption {
  default: string;
  description: string;
  options: Record<Option, string>;
}

export type FlagOptions = Record<FlagName, FlagOption>;
